<app-sistema-menu></app-sistema-menu>

<div class="columns is-gapless" style="height: 100vh; margin: 0; background-color: #f5f5f0;">
    
    <div class="column is-2 is-hidden-mobile">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>

    <div class="column is-10" style="display: flex; flex-direction: column; height: 100%;">
        
        <!-- Bloque 1: Top Bar -->
        <div class="card mb-4" style="margin: 1rem 1rem 0 1rem;">
            <div class="card-content has-background-primary has-rounded-corners">
                <div class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <div class="is-flex is-align-items-center">
                                <span class="icon has-text-white mr-3">
                                    <i class="fas fa-file-alt"></i>
                                </span>
                                <h1 class="title is-4 has-text-white is-marginless">Anexos 8 Generados</h1>
                            </div>
                        </div>
                    </div>
                    
                    <div class="level-right">
                        <div class="level-item">
                            <div class="field has-addons">
                                <div class="control">
                                    <input 
                                        class="input" 
                                        type="search" 
                                        placeholder="Buscar por folio, ciclo..." 
                                        [(ngModel)]="campo_buscar"
                                        (keyup.enter)="buscarTramites()"
                                        #buscarInput
                                        autocomplete="off"
                                        name="campo_buscar"
                                        id="campo_buscar">
                                </div>

                                <div class="control">
                                    <button 
                                        class="button is-info" 
                                        (click)="buscarTramites()"
                                        title="Buscar">
                                        <span class="icon">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <div class="level-item">
                            <button 
                                class="button is-light" 
                                (click)="actualizarListado()"
                                [class.is-loading]="isLoading"
                                title="Actualizar listado">
                                <span class="icon">
                                    <i class="fas fa-refresh"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bloque 2: Contenido/Listado -->
        <div class="card is-rounded is-flex-grow-1" style="margin: 0 1rem; border-radius: 8px; display: flex; flex-direction: column;">
            <div class="card-content is-flex-grow-1" style="padding: 0; display: flex; flex-direction: column;">
                
                <!-- Overlay de carga -->
                <div *ngIf="showLoadingOverlay" class="loading-overlay">
                    <div class="loading-content">
                        <div class="loading-spinner">
                            <i class="fas fa-spinner fa-spin fa-3x"></i>
                        </div>
                        <div class="loading-text">
                            <p>Trabajando, por favor espere...</p>
                        </div>
                    </div>
                </div>

                <!-- Tabla con header fijo y contenido scrollable -->
                <div class="table-container is-flex-grow-1" style="overflow: hidden;">
                    <div style="height: 100%; display: flex; flex-direction: column;">
                        <!-- Header fijo -->
                        <div style="flex-shrink: 0;">
                            <table class="table is-fullwidth is-striped is-hoverable is-narrow" style="margin: 0;">
                                <thead style="background-color: #f8f9fa;">
                                    <tr>
                                        <th class="has-text-left" style="width: 8%; padding: 0.75em 0.5em;">FOLIO</th>
                                        <th class="has-text-left" style="width: 8%; padding: 0.75em 0.5em;">CICLO</th>
                                        <th class="has-text-left" style="width: 25%; padding: 0.75em 0.5em;">CARRERAS</th>
                                        <th class="has-text-left" style="width: 20%; padding: 0.75em 0.5em;">PERIODOS</th>
                                        <th class="has-text-centered" style="width: 10%; padding: 0.75em 0.5em;">INSCRIPCIONES</th>
                                        <th class="has-text-centered" style="width: 12%; padding: 0.75em 0.5em;">RE INSCRIPCIONES</th>
                                        <th class="has-text-centered" style="width: 8%; padding: 0.75em 0.5em;">STATUS</th>
                                        <th class="has-text-centered" style="width: 9%; padding: 0.75em 0.5em;">ACCIONES</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <!-- Contenido scrollable -->
                        <div style="flex-grow: 1; overflow-y: auto; max-height: calc(100vh - 300px);">
                            <table class="table is-fullwidth is-striped is-hoverable is-narrow" style="margin: 0;">
                                <tbody>
                                    <tr *ngFor="let item of tramitesLista">
                                        <td class="has-text-left" style="width: 8%; padding: 0.75em 0.5em;">
                                            <span class="tag is-black is-light has-text-weight-bold">
                                                {{ item.folio || 'N/A' }}
                                            </span>
                                        </td>

                                        <td class="has-text-left" style="width: 8%; padding: 0.75em 0.5em;">
                                            {{ item.ciclo || 'N/A' }}
                                        </td>

                                        <td class="has-text-left" style="width: 25%; padding: 0.75em 0.5em;">
                                            {{ item.total_carreras || 0 }} Carrera(s)
                                        </td>

                                        <td class="has-text-left" style="width: 20%; padding: 0.75em 0.5em;">
                                            {{ item.total_periodos || 0 }} Periodo(s)
                                        </td>
                                        
                                        <td class="has-text-centered" style="width: 10%; padding: 0.75em 0.5em;">
                                            <span class="tag is-info is-light">
                                                {{ item.total_inscripciones || 0 }}
                                            </span>
                                        </td>

                                        <td class="has-text-centered" style="width: 12%; padding: 0.75em 0.5em;">
                                            <span class="tag is-warning is-light">
                                                {{ item.total_reinscripciones || 0 }}
                                            </span>
                                        </td>

                                        <td class="has-text-centered" style="width: 8%; padding: 0.75em 0.5em;">
                                            <span class="tag is-success is-light">
                                                Activo
                                            </span>
                                        </td>

                                        <td class="has-text-centered" style="width: 9%; padding: 0.75em 0.5em;">
                                            <div class="buttons are-small is-justify-content-center">
                                                <button class="button is-info is-outlined" 
                                                        (click)="abrirModalAnexo(item)"
                                                        title="Ver detalle del Anexo 8">
                                                    <span class="icon">
                                                        <i class="fas fa-list"></i>
                                                    </span>
                                                    <span>Ver A8</span>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngIf="tramitesLista.length === 0 && !isLoading">
                                        <td colspan="8" class="has-text-centered py-5" style="padding: 0.75em 0.5em;">
                                            <span class="has-text-grey">
                                                <i class="fas fa-inbox mr-2"></i>
                                                No se encontraron anexos 8
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bloque 3: Footer/Paginación (placeholder) -->
        <div class="card is-rounded mt-4" style="margin: 0 1rem 1rem 1rem; border-radius: 8px;">
            <div class="card-content">
                <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                    <a class="pagination-previous" [class.is-disabled]="pagina === 0" (click)="pagina = pagina - 1; obtenerTramites()">Anterior</a>
                    <a class="pagination-next" (click)="pagina = pagina + 1; obtenerTramites()">Siguiente</a>
                    <ul class="pagination-list">
                        <li><span class="pagination-link is-current">Página {{ pagina + 1 }}</span></li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</div>

<!-- Modal para Detalle del Anexo 8 -->
<div class="modal modal-alumnos" [class.is-active]="showAnexoModal">
    <div class="modal-background"></div>
    <div class="modal-card modal-card-alumnos">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Detalle del Anexo 8 - Folio: {{ anexoDetalle?.folio || 'N/A' }} | Ciclo: {{ anexoDetalle?.ciclo || 'N/A' }}
            </p>
            <button class="delete" aria-label="close" (click)="cerrarModalAnexo()"></button>
        </header>
        <section class="modal-card-body modal-card-body-alumnos">
            <!-- Resumen estadístico -->
            <div class="estadisticas-container" style="display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 20px;">
                <div class="estadistica-card" style="background: white; border-radius: 8px; padding: 1rem; flex: 1; min-width: 150px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div class="estadistica-content" style="display: flex; align-items: center; gap: 0.5rem;">
                        <div class="estadistica-icon has-text-primary">
                            <i class="fas fa-graduation-cap fa-2x"></i>
                        </div>
                        <div class="estadistica-text">
                            <div class="estadistica-value" style="font-size: 1.5rem; font-weight: bold;">{{ anexoDetalle?.total_carreras || 0 }}</div>
                            <div class="estadistica-label" style="font-size: 0.8rem; color: #666;">Carreras</div>
                        </div>
                    </div>
                </div>

                <div class="estadistica-card" style="background: white; border-radius: 8px; padding: 1rem; flex: 1; min-width: 150px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div class="estadistica-content" style="display: flex; align-items: center; gap: 0.5rem;">
                        <div class="estadistica-icon has-text-warning">
                            <i class="fas fa-clock fa-2x"></i>
                        </div>
                        <div class="estadistica-text">
                            <div class="estadistica-value" style="font-size: 1.5rem; font-weight: bold;">{{ anexoDetalle?.total_periodos || 0 }}</div>
                            <div class="estadistica-label" style="font-size: 0.8rem; color: #666;">Periodos</div>
                        </div>
                    </div>
                </div>

                <div class="estadistica-card" style="background: white; border-radius: 8px; padding: 1rem; flex: 1; min-width: 150px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div class="estadistica-content" style="display: flex; align-items: center; gap: 0.5rem;">
                        <div class="estadistica-icon has-text-info">
                            <i class="fas fa-flag fa-2x"></i>
                        </div>
                        <div class="estadistica-text">
                            <div class="estadistica-value" style="font-size: 1.5rem; font-weight: bold;">{{ anexoDetalle?.total_inscripciones || 0 }}</div>
                            <div class="estadistica-label" style="font-size: 0.8rem; color: #666;">Inscripciones</div>
                        </div>
                    </div>
                </div>

                <div class="estadistica-card" style="background: white; border-radius: 8px; padding: 1rem; flex: 1; min-width: 150px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div class="estadistica-content" style="display: flex; align-items: center; gap: 0.5rem;">
                        <div class="estadistica-icon has-text-danger">
                            <i class="fas fa-redo fa-2x"></i>
                        </div>
                        <div class="estadistica-text">
                            <div class="estadistica-value" style="font-size: 1.5rem; font-weight: bold;">{{ anexoDetalle?.total_reinscripciones || 0 }}</div>
                            <div class="estadistica-label" style="font-size: 0.8rem; color: #666;">Reinscripciones</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tabla de programas y periodos -->
            <div class="card">
                <div class="card-header">
                    <h2 class="card-header-title">Detalles por Programas Académicos y Periodos</h2>
                </div>
                <div class="card-content" style="padding: 1rem;">
                    <div class="table-container">
                        <div class="fixed-header-table" style="max-height: 400px; overflow-y: auto;">
                            <table class="table is-fullwidth is-striped">
                                <thead style="position: sticky; top: 0; background-color: #f5f5f0; z-index: 10;">
                                    <tr>
                                        <th class="has-text-left">PROGRAMA ACADÉMICO</th>
                                        <th class="has-text-left">RVOE</th>
                                        <th class="has-text-left">PERIODO</th>
                                        <th class="has-text-centered">INSCRIPCIONES</th>
                                        <th class="has-text-centered">REINSCRIPCIONES</th> 
                                        <th class="has-text-centered">OPCIONES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let programa of programasPeriodos">
                                        <td class="has-text-left">{{ programa.programa_academico || 'N/A' }}</td>
                                        <td class="has-text-left">{{ programa.rvoe || 'N/A' }}</td>
                                        <td class="has-text-left">{{ programa.periodo || 'N/A' }}</td>
                                        <td class="has-text-centered">{{ programa.inscripciones || 0 }}</td>
                                        <td class="has-text-centered">{{ programa.reinscripciones || 0 }}</td>
                                        <td class="has-text-centered">
                                            <button class="button is-small btn-opciones" 
                                                    (click)="abrirModalAlumnos(programa)"
                                                    title="Ver alumnos">
                                                <span class="icon">
                                                    <i class="fas fa-list"></i>
                                                </span>
                                                <span>Ver alumnos</span>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr *ngIf="programasPeriodos.length === 0">
                                        <td colspan="6" class="has-text-centered">
                                            No hay datos de programas disponibles.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalAnexo()">Cerrar</button>
        </footer>
    </div>
</div>

<!-- Modal para Alumnos del Programa -->
<div class="modal modal-alumnos" [class.is-active]="showAlumnosModal">
    <div class="modal-background"></div>
    <div class="modal-card modal-card-alumnos">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ modalAlumnosTitle }}</p>
            <div>
                <button class="button is-small btn-excel mr-2" 
                        (click)="exportarExcelAlumnos()"
                        title="Exportar a Excel"
                        [disabled]="alumnosData.length === 0">
                    <span class="icon">
                        <i class="fas fa-file-excel"></i>
                    </span>
                    <span>Excel</span>
                </button>
                <button class="delete" aria-label="close" (click)="cerrarModalAlumnos()"></button>
            </div>
        </header>
        <section class="modal-card-body modal-card-body-alumnos">
            <div class="table-container-alumnos">
                <table class="table table-alumnos is-fullwidth">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Estatus</th>
                            <th>Año del ciclo escolar</th>
                            <th>Nombre del alumno</th>
                            <th>Primer Apellido</th>
                            <th>Segundo Apellido</th>
                            <th>Género</th>
                            <th>CURP</th>
                            <th>Fecha de Nacimiento</th>
                            <th>País de Nacimiento</th>
                            <th>Entidad Federativa o Ciudad de Nacimiento</th>
                            <th>País de Procedencia</th>
                            <th>Idioma/Lengua</th>
                            <th>Necesidad Educativa Especial</th>
                            <th>Presenta Antecedente Académico</th>
                            <th>CCT</th>
                            <th>Matrícula Institucional</th>
                            <th>Nivel Educativo</th>
                            <th>Clave de la Institución</th>
                            <th>Clave de Carrera</th>
                            <th>Turno</th>
                            <th>Número de Acuerdo de RVOE</th>
                            <th>Fecha de Acuerdo de RVOE</th>
                            <th>Modalidad Educativa</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let alumno of alumnosData; let i = index">
                            <td>{{ i+1 }}</td>
                            <td>{{ alumno.estatus || 'N/A' }}</td>
                            <td>{{ alumno.anio_ciclo_escolar || 'N/A' }}</td>
                            <td>{{ alumno.nombre_alumno || 'N/A' }}</td>
                            <td>{{ alumno.primer_apellido || 'N/A' }}</td>
                            <td>{{ alumno.segundo_apellido || 'N/A' }}</td>
                            <td>{{ alumno.genero || 'N/D' }}</td>
                            <td>{{ alumno.curp || 'N/A' }}</td>
                            <td>{{ alumno.fecha_nacimiento || 'N/A' }}</td>
                            <td>{{ alumno.pais_nacimiento || 'N/A' }}</td>
                            <td>{{ alumno.entidad_federativa || 'N/A' }}</td>
                            <td>{{ alumno.pais_procedencia || 'N/A' }}</td>
                            <td>{{ alumno.idioma || 'N/A' }}</td>
                            <td>{{ alumno.necesidad_educativa_especial || 'N/A' }}</td>
                            <td>{{ alumno.presenta_antecedente_academico || 'N/A' }}</td>
                            <td>{{ alumno.cct || 'N/A' }}</td>
                            <td>{{ alumno.matricula_institucional || 'N/A' }}</td>
                            <td>{{ alumno.nivel_educativo || 'N/A' }}</td>
                            <td>{{ alumno.clave_institucion || 'N/A' }}</td>
                            <td>{{ alumno.clave_carrera || 'N/A' }}</td>
                            <td>{{ alumno.turno || 'N/A' }}</td>
                            <td>{{ alumno.numero_acuerdo_rvoe || 'N/A' }}</td>
                            <td>{{ alumno.fecha_acuerdo_rvoe || 'N/A' }}</td>
                            <td>{{ alumno.modalidad_educativa || 'N/A' }}</td>
                        </tr>
                        <tr *ngIf="alumnosData.length === 0">
                            <td colspan="24" class="has-text-centered">
                                No hay datos de alumnos disponibles.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalAlumnos()">Cerrar</button>
        </footer>
    </div>
</div>